<template>
	<vx-card :title='$t("BusinessTrips")'>
		<vs-table ref="table" pagination :max-items="50" search :data="businessTrips" v-if="renderTable">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button v-if="$checkPermission(1701)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addBusinessTripPrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ businessTrips.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : businessTrips.length }} of {{ businessTrips.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="title">{{$t("Title")}}</vs-th>
				<vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
				<vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

						<vs-td :data="data[index].title">
							{{ data[index].title }}
						</vs-td>

						<vs-td :data="data[index].start_time">
							{{ moment(data[index].start_time).format('DD/MM/YYYY') }}
						</vs-td>

						<vs-td :data="data[index].end_time">
							{{ moment(data[index].end_time).format('DD/MM/YYYY') }}
						</vs-td>

						<template slot="expand">

							<div class="vx-row w-full">
								<div v-if="$checkPermission(1701)" class="vx-col xl:w-1/12 lg:w-2/12 w-full p-6">
									<vs-button type="border" @click="openBusinessTripEdit(data[index])">{{$t("Edit")}}</vs-button>
								</div>
								<div class="vx-col xl:w-6/12 lg:w-5/12 w-full p-6">
									<h4>{{$t("Description")}}</h4>
									<p class="mt-3" style="white-space: pre-wrap">{{ data[index].description }}</p>
									<vs-divider class="xl:invisible lg:invisible md:visible"/>
								</div>
								<div class="vx-col xl:w-5/12 lg:w-5/12 w-full p-6">
									<h4 class="mb-3">{{$t("CoWorkers")}}</h4>
									<p v-if="$store.getters.companyUsers[item2]" :key="index2" v-for="(item2,index2) in data[index].company_users">- {{$store.getters.companyUsers[item2].name}}</p>
								</div>
							</div>

						</template>

					</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addBusinessTripPrompt">
			<div>
				<p class="mt-6">{{$t("Title")}}</p>
				<vs-input v-model="addObject['title']" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("StartTime")}}</p>
				<flat-pickr class="w-full" :config="configDateTimePicker" v-model="addObject['start_time']"/>
				<p class="mt-6">{{$t("EndTime")}}</p>
				<flat-pickr class="w-full" :config="configDateTimePicker" v-model="addObject['end_time']"/>
				<p class="mt-6">{{$t("CoWorkers")}}</p>
				<vs-select autocomplete multiple class="selectExample w-full" v-model="addObject['company_users']">
					<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in $store.getters.companyUsers" />
				</vs-select>
				<p class="mt-6">{{$t("Description")}}</p>
				<vs-textarea v-model="addObject['description']" class="w-full mb-6" />
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addBusinessTrip">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>

		<vs-popup :title="$t('Edit')" :active.sync="editBusinessTripPrompt">
			<div>
				<p class="mt-6">{{$t("Title")}}</p>
				<vs-input v-model="editObject['title']" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("StartTime")}}</p>
				<flat-pickr class="w-full" :config="configDateTimePicker" v-model="editObject['start_time']"/>
				<p class="mt-6">{{$t("EndTime")}}</p>
				<flat-pickr class="w-full" :config="configDateTimePicker" v-model="editObject['end_time']"/>
				<p class="mt-6">{{$t("CoWorkers")}}</p>
				<vs-select autocomplete multiple class="selectExample w-full" v-model="editObject['company_users']">
					<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in $store.getters.companyUsers" />
				</vs-select>
				<p class="mt-6">{{$t("Description")}}</p>
				<vs-textarea v-model="editObject['description']" class="w-full mb-6" />
				<vs-divider/>
				<vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editBusinessTrip">{{$t("Change")}}</vs-button>
				<vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeBusinessTrip">{{$t("Delete")}}</vs-button>
			</div>
		</vs-popup>
	</vx-card>
</template>
<script>

	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	export default {
		components: {
			flatPickr,
		},
		data() {
			return {

				configDateTimePicker: {
					dateFormat: 'Y-m-d',
					locale: {
						firstDayOfWeek: 1
					}
				},

				selected: {},
				businessTrips: [],
				itemsPerPage: 20,
				isMounted: false,
				addBusinessTripPrompt: false,
				editBusinessTripPrompt: false,

				renderTable: true,

				addObject: {},
				editObject: {},

				expanded: []
			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
		},
		methods: {
			openBusinessTripEdit(inObj) {
				if(!this.$checkPermission(1701)) return;
				this.editObject = JSON.parse(JSON.stringify(inObj));
				this.editBusinessTripPrompt = true;
			},
			updateBusinessTrips() {
				const thisIns = this;
				this.$http.get('/api/v1/business_trip/')
						.then(function (response) {
							thisIns.businessTrips = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addBusinessTrip() {
				const thisIns = this;
				this.$http.post('/api/v1/business_trip/', {
					title: thisIns.addObject['title'],
					start_time: thisIns.moment(thisIns.addObject['start_time']),
					end_time: thisIns.moment(thisIns.addObject['end_time']),
					description: thisIns.addObject['description'],
					company_users: thisIns.addObject['company_users'],
				}).then(function () {
					thisIns.updateBusinessTrips();
					thisIns.addBusinessTripPrompt = false;

					thisIns.addObject['title'] = "";
					thisIns.addObject['start_time'] = new Date();
					thisIns.addObject['end_time'] = new Date();
					thisIns.addObject['description'] = "";
					thisIns.addObject['company_users'] = [];
				}).catch(function (error) {
					thisIns.addBusinessTripPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			editBusinessTrip() {
				const thisIns = this;
				this.$http.put('/api/v1/business_trip/' + this.editObject["id"], {
					title: thisIns.editObject['title'],
					start_time: thisIns.moment(thisIns.editObject['start_time']),
					end_time: thisIns.moment(thisIns.editObject['end_time']),
					description: thisIns.editObject['description'],
					company_users: thisIns.editObject['company_users'],
				}).then(function () {
					thisIns.updateBusinessTrips();
					thisIns.editBusinessTripPrompt = false;
				}).catch(function (error) {
					thisIns.editBusinessTripPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			removeBusinessTrip() {
				const thisIns = this;
				this.$http.delete('/api/v1/business_trip/' + this.editObject["id"])
				.then(function () {
					thisIns.updateBusinessTrips();
					thisIns.editBusinessTripPrompt = false;
					thisIns.renderTable = false;
					thisIns.$nextTick(() => {
						thisIns.renderTable = true;
					});
				}).catch(function (error) {
					thisIns.editBusinessTripPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			}
		},
		created() {
			this.updateBusinessTrips();
			this.addObject['company_users'] = [];
			this.editObject['company_users'] = [];
		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addBusinessTripPrompt){
				this.addBusinessTripPrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
